export default {"src":"/_next/static/media/series-placeholder.15645ca1.svg","height":36,"width":36};